export default window._cmsContent['solar/enter-postcode']